import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  primaryContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(5),
  },
  inputField: {
    width: theme.spacing(59.37),
  },
  externalButton: {
    marginTop: theme.spacing(3),
  },
  horizontalDevider: {
    backgroundColor: theme.palette.dividerV2.main,
    width: '100%',
    height: theme.spacing(0.125),
    borderRadius: theme.spacing(0.5),
  },
  buttonText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.5',
    color: '#381E1C',
  },
  rowTitle: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.5',
    color: '#000000DE',
  },
  lightText: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0',
    color: '#6A777A',
  },
  rowBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  rowConatiner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
